import { render, staticRenderFns } from "./m-form-connect-partners.vue?vue&type=template&id=1649a50a&scoped=true&lang=pug&"
import script from "./m-form-connect-partners.vue?vue&type=script&lang=js&"
export * from "./m-form-connect-partners.vue?vue&type=script&lang=js&"
import style0 from "./m-form-connect-partners.vue?vue&type=style&index=0&id=1649a50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1649a50a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VForm,VRow})
